import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { Globe } from 'lucide-react';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from './ui/dropdown-menu';
import { Button } from './ui/button';

const languages = [
  { code: 'it', name: 'Italiano', flag: 'it' },
  { code: 'sq', name: 'Shqip', flag: 'al' },
  { code: 'ar', name: 'العربية', flag: 'sa' },
  { code: 'zh', name: '中文', flag: 'cn' },
  { code: 'ur', name: 'اردو', flag: 'pk' },
  { code: 'fr', name: 'Français', flag: 'fr' }
];

const LanguageSelector = () => {
  const { language, setLanguage } = useLanguage();
  const currentLang = languages.find(lang => lang.code === language) || languages[0];

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" className="flex items-center space-x-2" data-testid="language-selector">
          <img 
            src={`https://flagcdn.com/w40/${currentLang.flag}.png`} 
            alt={currentLang.name}
            className="w-6 h-4 rounded-sm"
          />
          <span>{currentLang.name}</span>
          <Globe className="h-4 w-4" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-48 bg-white border shadow-lg">
        {languages.map((lang) => (
          <DropdownMenuItem
            key={lang.code}
            onClick={() => setLanguage(lang.code)}
            className="flex items-center space-x-3 cursor-pointer hover:bg-gray-100"
            data-testid={`language-option-${lang.code}`}
          >
            <img 
              src={`https://flagcdn.com/w40/${lang.flag}.png`} 
              alt={lang.name}
              className="w-6 h-4 rounded-sm"
            />
            <span className="text-gray-900">{lang.name}</span>
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default LanguageSelector;
